module.exports = __webpack_public_path__ + "img/P8_popup_thumb_5_th.959ede13.png";